// Tracciamento delle richieste inviate dai form di contatto (pagina contatti e landing cronometraggio).
// Richieste commerciali (organizzatori/cronometraggio) = conversioni Google Ads, con un valore
// indicativo per far distinguere all'algoritmo i lead più preziosi. Le altre richieste sono
// assistenza agli atleti: tracciate a parte, NON vanno marcate come conversione.
var LEAD_VALUES = {
	timing_service: 200,
	organizer: 100
};

// Tag Google caricato in app-shell.blade.php; window.IDC_ADS contiene le etichette di conversione Ads.
function track(topic, email) {
	if (typeof window.gtag !== "function") {
		return;
	}
	if (!LEAD_VALUES.hasOwnProperty(topic)) {
		window.gtag("event", "contact_support", { contact_topic: topic });
		return;
	}
	// Enhanced Conversions: Google cifra l'email (SHA-256) prima dell'invio.
	window.gtag("set", "user_data", { email: (email || "").trim().toLowerCase() });
	window.gtag("event", "generate_lead", { lead_topic: topic, value: LEAD_VALUES[topic], currency: "EUR" });
	var sendTo = window.IDC_ADS && window.IDC_ADS.conversions[topic];
	if (sendTo) {
		window.gtag("event", "conversion", { send_to: sendTo, value: LEAD_VALUES[topic], currency: "EUR" });
	}
}

module.exports = { track: track };
